// extracted by mini-css-extract-plugin
module.exports = {"text":"styles-module__text___1EymJ","reducedFinishScreenImage":"styles-module__reducedFinishScreenImage___1rQNt"};